import './App.css';
import './MediaQueries.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'leaflet/dist/leaflet.css'
import ScrollToTop from './Components/ScrollToTop';
import Home from './Pages/Home';
import Footer from './Components/Footer';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import About from './Pages/About';
import OurTeam from './Pages/OurTeam';
import Infrastructure from './Pages/Infrastructure';
import Research from './Pages/Research';
import OurPresence from './Pages/OurPresence';
import Csr from './Pages/Csr';
import Trade from './Pages/Trade';
import BentoniteCommon from './Pages/BentoniteCommon';
import IndustrialCommon from './Pages/IndustrialCommon';
import BlogCommon from './Pages/BlogCommon';
import Contact from './Pages/Contact';
import BentoniteDetail from './Pages/BentoniteDetail';
import IndustrialDetail from './Pages/IndustrialDetail';
import CountryCommon from './Pages/CountryCommon';
import CountryProducts from './Pages/CountryProducts';
import NotFound from './Pages/NotFound';
import BlogDetail from './Pages/BlogDetail';
import Sitemap from './Pages/Sitemap';

function App() {
  return (
    <>
     <BrowserRouter>
     <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/about-us/our-group-companies-team" element={<OurTeam />} />
        <Route path="/about-us/infrastructure" element={<Infrastructure />} />
        <Route path="/about-us/research-quality" element={<Research/>} />
        <Route path="/about-us/our-presence" element={<OurPresence/>} />
        <Route path="/about-us/csr-sustainability" element={<Csr/>} />
        <Route path="/about-us/trade-participations-honours" element={<Trade/>} />
        <Route path="/bentonite-minerals" element={<BentoniteCommon/>} />
        <Route path="/bentonite-minerals/:slug" element={<BentoniteDetail />} />
        <Route path="/industrial-minerals" element={<IndustrialCommon />} />
        <Route path="/industrial-minerals/:slug" element={<IndustrialDetail />} />
        <Route path="/blogs" element={<BlogCommon />} />
        <Route path="/blogs/:url" element={<BlogDetail/>} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/:slug" element={<CountryCommon />} />
        <Route path="/:country/:slug" element={<CountryProducts />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
      <Footer />
      </BrowserRouter>
      </>
  );
}

export default App;
